import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { getNewMovies } from '@/mocks/movies';

export default function LatestSection() {
  const newMovies = getNewMovies(8);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              最新上线
            </h2>
            <p className="text-sm text-foreground-500 mt-1">新鲜出炉的热门影片</p>
          </div>
          <Link
            to="/category/kehuan"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {newMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}